// ======================================================================
// File Name       : TranslateConfirm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { convertLanguageName } from '../../utils/ContentUtils';

class TranslateConfirm extends React.Component {

  render() {
    const { contentSecernId, contentName, languageCode } = this.props.formValues;
    return (
      <div>
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={3} as={Form.Label} className="padding-left-clear">
                コンテンツ識別ID
              </Col>
              <Col sm={9} as={Form.Label}>
                {contentSecernId}
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={3} as={Form.Label} className="padding-left-clear">
                コンテンツ名
              </Col>
              <Col sm={9} as={Form.Label}>
                {contentName}
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={3} as={Form.Label} className="padding-left-clear">
                言語
              </Col>
              <Col sm={9} as={Form.Label}>
                {convertLanguageName(languageCode)}
              </Col>
            </Col>
          </Form.Group>
        </Col>
      </div>
    );
  }
}
export default TranslateConfirm;
